module.exports = __webpack_public_path__ + "img/technician1.16de2c6a.png";